export default __webpack_public_path__ + "static/media/icon-string.5f7fe81d.svg";